<div class="row" style="margin-top:65px">
  <div class="col-12">
    <a [routerLink]="'/user-dashboard'">
      <i class="fas fa-fw fa-home me-2"></i>Home<i class="fas fa-fw fa-chevron-right mx-2"></i>
    </a>
    <a [routerLink]="'/admin/billing'">
      <i class="fas fa-fw fa-file-invoice-dollar me-2"></i>Billing Center<i class="fas fa-fw fa-chevron-right mx-2"></i>
    </a>
    <span class="c_bluedk"><i class="fas fa-fw fa-cog mx-2"></i>Bill Configuration Tool</span>
  </div>
</div>
<div class="row">
  <div class="col-12 col-lg-8">
    <div *ngIf="error" class="error">{{ error }}</div>
    <div *ngIf="loading" class="loading">Loading...</div>

    <table class="table table-sm" *ngIf="!loading">
      <thead>
        <tr>
          <th class="th-left">Client</th>
          <th class="th-center col-narrow">No Bill</th>
          <th class="th-center col-narrow">Time</th>
          <th class="th-center col-narrow">AUM</th>
          <th class="th-center col-narrow d-none">Expenses</th>
          <th class="th-center col-save">Save</th>
        </tr>
      </thead>

      <tbody>
        <tr *ngFor="let row of rows" [class.row-dirty]="isDirty(row)">
          <td class="client-cell">{{ row.old_name }}</td>

          <td class="text-center">
            <input type="checkbox"
                   class="cb"
                   [checked]="row.no_bill === 1"
                   (change)="onToggleNoBill(row)" />
          </td>

          <td class="text-center">
            <input type="checkbox"
                   class="cb"
                   [checked]="row.section_time === 1"
                   [disabled]="row.no_bill === 1"
                   (change)="onToggleSection(row, 'section_time')" />
          </td>

          <td class="text-center">
            <input type="checkbox"
                   class="cb"
                   [checked]="row.section_aum === 1"
                   [disabled]="row.no_bill === 1"
                   (change)="onToggleSection(row, 'section_aum')" />
          </td>

          <td class="text-center d-none">
            <input type="checkbox"
                   class="cb"
                   [checked]="row.section_expenses === 1"
                   [disabled]="row.no_bill === 1"
                   (change)="onToggleSection(row, 'section_expenses')" />
          </td>

          <td class="text-center">
            <button class=" btn btn-sm btn-dark" (click)="saveRow(row)">Save</button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>

